var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.MODAL_ID,
        title: _vm.title,
        size: "lg",
        centered: "",
        "ok-title": "Save",
      },
      on: {
        ok: function ($event) {
          $event.preventDefault()
          return _vm.onSave.apply(null, arguments)
        },
      },
      scopedSlots: _vm._u([
        {
          key: "modal-title",
          fn: function () {
            return [
              _c("div", { staticClass: "d-flex justify-content-between" }, [
                _c(
                  "h5",
                  {
                    staticClass:
                      "modal-title d-flex justify-content-between align-items-center flex-wrap",
                  },
                  [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                ),
              ]),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function ({ cancel, ok }) {
            return [
              _c("div", { staticClass: "w-100 d-flex justify-content-end" }, [
                _c(
                  "div",
                  { staticClass: "d-flex" },
                  [
                    _c("b-button", { on: { click: cancel } }, [
                      _vm._v("\n          Cancel\n        "),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "mx-1" }),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "primary", disabled: _vm.isSaving },
                        on: { click: ok },
                      },
                      [_vm._v("\n          Save\n        ")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "my-3" }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c("label", [_vm._v("Customers")]),
              _vm._v(" "),
              _c("Multiselect", {
                attrs: {
                  "track-by": "name",
                  label: "name",
                  placeholder: "Select Customer",
                  options: _vm.customers,
                },
                on: { input: _vm.onChangeCustomer },
                model: {
                  value: _vm.selectedCustomer,
                  callback: function ($$v) {
                    _vm.selectedCustomer = $$v
                  },
                  expression: "selectedCustomer",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "align-content-end", attrs: { cols: "6" } },
            [
              _c("Multiselect", {
                attrs: {
                  placeholder: "Filter Templates",
                  multiple: "",
                  loading: _vm.isLoading,
                  options: _vm.getTags,
                  "close-on-select": false,
                  "show-labels": false,
                },
                on: { input: _vm.onChangeTags },
                model: {
                  value: _vm.tags,
                  callback: function ($$v) {
                    _vm.tags = $$v
                  },
                  expression: "tags",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "12" } }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-between mt-3" },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", { staticClass: "mx-3" }),
                ]),
                _vm._v(" "),
                _c(
                  "b-checkbox",
                  {
                    staticClass: "float-right",
                    attrs: { switch: "" },
                    on: {
                      change: function ($event) {
                        return _vm.$refs.templatesSelect.activate()
                      },
                    },
                    model: {
                      value: _vm.galleryView,
                      callback: function ($$v) {
                        _vm.galleryView = $$v
                      },
                      expression: "galleryView",
                    },
                  },
                  [_vm._v("\n          Gallery view\n        ")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "d-flex" },
              [
                _c("Multiselect", {
                  ref: "templatesSelect",
                  class: [
                    "templates-dropdown",
                    { "gallery-view": _vm.galleryView },
                  ],
                  attrs: {
                    "track-by": "name",
                    label: "name",
                    placeholder: `Select Template${
                      _vm.isMultiSizes ? "s" : ""
                    }`,
                    multiple: _vm.isMultiSizes,
                    loading: _vm.isLoading,
                    options: _vm.getTemplatesOptionsFormatted,
                    "close-on-select": !_vm.isMultiSizes,
                    "show-labels": false,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function ({ values, isOpen }) {
                        return [
                          values.length
                            ? _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !isOpen,
                                      expression: "!isOpen",
                                    },
                                  ],
                                  staticClass: "multiselect__single",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(values.length) +
                                      " selected\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                    {
                      key: "option",
                      fn: function (props) {
                        return [
                          props.option.name !== "Select all"
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "select-template-thumbnail-container",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "select-template-thumbnail",
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: props.option.thumbnail,
                                          alt: props.option.name,
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                props.option.$groupLabel || props.option.name
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.selectedTemplate,
                    callback: function ($$v) {
                      _vm.selectedTemplate = $$v
                    },
                    expression: "selectedTemplate",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "my-3" }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-row",
                [
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { disabled: _vm.applyToAllProducts },
                      model: {
                        value: _vm.swapAddAsNewTemplate,
                        callback: function ($$v) {
                          _vm.swapAddAsNewTemplate = $$v
                        },
                        expression: "swapAddAsNewTemplate",
                      },
                    },
                    [_vm._v("\n          Add as new template\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-row",
                { staticClass: "mt-2" },
                [
                  _c(
                    "b-form-checkbox",
                    {
                      on: { change: _vm.onApplyToAllChange },
                      model: {
                        value: _vm.applyToAllProducts,
                        callback: function ($$v) {
                          _vm.applyToAllProducts = $$v
                        },
                        expression: "applyToAllProducts",
                      },
                    },
                    [_vm._v("\n          Apply to all products\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }